<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap pa-3>
      <v-flex lg4 sm12 py-0>
        <v-select
          v-if="currentItem.ID == 0"
          label="Mã bao hàng"
          class="input-group--focused pt-0"
          :items="packages"
          v-model="currentItem.BigPackageID"
          item-text="PackageCode"
          item-value="ID"
          :disabled="readOnly"
          :rules="[(v) => !!v || 'Hãy nhập mã bao hàng']"
          @change="onChangePackage"
        >
        <template slot="no-data">
          <div>Không có dữ liệu bao hàng nhập kho</div>
        </template>
        </v-select>
        <v-text-field
          v-if="currentItem.ID > 0"
          label="Mã bao hàng"
          v-model="currentItem.PackageCode"
          class="input-group--focused pt-0"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg8 sm12 py-0>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Ngày nhập kho"
          :value="getCreatedDateFormat"
          class="input-group--focused font-weight-bold"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12  py-0>
        <h-currency-input
          label="Tổng phí ship"
          v-model="currentItem.Amount"
          :decimal="0"
          class="input-group--focused"
          readonly
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12  py-0>
      </v-flex>
      <v-flex lg4 sm12  py-0>
        <h-currency-input
          label="Số kiện (TQ)"
          v-model="currentItem.Volume"
          :decimal="0"
          class="input-group--focused"
          readonly
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <h-currency-input
          label="Số kiện đã nhập"
          v-model="currentItem.ReceivedVolume"
          :decimal="0"
          showClass="input-group--focused font-weight-bold text-red"
          color="red darken-2"
          readonly
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Tổng cân nặng (TQ)"
          type="number"
          v-model="currentItem.Weight"
          class="input-group--focused"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Tổng cân nặng đã nhập"
          type="number"
          v-model="currentItem.ReceivedWeight"
          class="input-group--focused font-weight-bold text-red"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg12 md12 sm12 py-0>
        <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
      </v-flex>
      <v-flex lg12 md12 sm12 py-0>
        <v-text-field
          label="Mã vận đơn"
          ref="trancode"
          v-model="transactionCode"
          class="input-group--focused pt-0"
          @input="codeChanged"
          @keyup.enter="manualChanged"
          :disabled="readOnly"
        ></v-text-field>
      </v-flex>
      <v-flex lg12 md12 sm12 pa-0>
        <v-data-table fixed-header height= "70vh" 
          :headers="headers"
          :items="currentItem.Packages"
          :options.sync="pagination"
          :server-items-length="currentItem.Volume"
          :footer-props="items_per_page"
          :must-sort="true"
          :loading="loading"
          :mobile-breakpoint="100"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td v-bind:class="item.OrderID == null ? 'text-red' : ''">{{ item.TransactionCode }}</td>
              <td>{{ item.OrderID }}</td>
              <td>{{ item.Username }}</td>
              <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
              <td class="text-end">{{ item.FeeShip | currency}}</td>
              <td class="text-end" v-if="item.Status >= 4">{{ item.Length | currency }}</td>
              <td class="text-end" v-else>
                <v-edit-dialog :return-value.sync="item.Length" large lazy persistent @save="saveTranWeight(item)">
                  <div>{{ item.Length | currency }}</div>
                  <template v-slot:input>
                    <v-text-field v-model="item.Length" type="number" label="Chiều dài" single-line autofocus></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status >= 4">{{ item.Width | currency }}</td>
              <td class="text-end" v-else>
                <v-edit-dialog :return-value.sync="item.Width" large lazy persistent @save="saveTranWeight(item)">
                  <div>{{ item.Width | currency}}</div>
                  <template v-slot:input>
                    <v-text-field v-model="item.Width" type="number" label="Chiều rộng" single-line autofocus></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status >= 4">{{ item.Height | currency }}</td>
              <td class="text-end" v-else>
                <v-edit-dialog :return-value.sync="item.Height" large lazy persistent @save="saveTranWeight(item)">
                  <div>{{ item.Height | currency}}</div>
                  <template v-slot:input>
                    <v-text-field v-model="item.Height" type="number" label="Chiều cao" single-line autofocus></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
              <td class="text-end" v-if="item.Status >= 4">{{ item.Weight | currency('', 1)}}</td>
              <td class="text-end" v-else>
                <v-edit-dialog :return-value.sync="item.Weight" large lazy persistent @save="saveTranWeight(item)">
                  <div>{{ item.Weight | currency('', 1)}}</div>
                  <template v-slot:input>
                    <v-text-field v-model="item.Weight" type="number" label="Cân nặng" step=".1" single-line autofocus></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-center">
                <v-icon medium class="mr-2" color="red darken-2" @click="printTransaction(item.Weight, item.TransactionCode, item.Username, item.OrderID, item.NumberOfCode)">print</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment";
import { getCurrentTime } from "@/commons/utils";
import { print_transaction } from "@/commons/hpod";
export default {
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 20;
    
    return {
      appLoading: false,
      useBarcodeReader: true,
      package_status: configs.PACKAGE_STATUS,
      transactionCode: "",
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
         {
          text: "Order ID",
          value: "OrderID",
          quickSearch: true,
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
         {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: dataType["Enum"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều dài",
          value: "Length",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều rộng",
          value: "Width",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều cao",
          value: "Height",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Thể tích",
          value: "Volume",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [20, 30, 50] },
      currentTime: getCurrentTime()
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    packageId() {
      if(this.packageId > 0) {
        this.$router.push({
        name: "StoreManagerVNDetail",
        params: {
          Pid: this.packageId,
          title: "Chi tiết nhập kho"
        }
      });
      this.refreshData();
      }
      this.appLoading = false;
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackageVn.selected,
      totalPackage: state => {
        state.bigPackageVn.selected.Packages
          ? state.bigPackageVn.selected.Packages.length
          : 0;
      },
      loading: state => state.bigPackageVn.loading,
      trancodeDetail: state => state.bigPackageVn.trancodeDetail,
      packages: state => state.bigPackage.notTransit
    }),
    packageId() {
      return this.currentItem && this.currentItem.ID > 0
        ? this.currentItem.ID
        : Number(this.$route.params.Pid);
    },
    getCreatedDateFormat() {
      return moment(this.currentItem.CreatedDate).format("DD-MM-YYYY HH:mm:ss");
    }
  },
  mounted() {
    this.refreshData();
    this.getListPackageNotTran();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA");
  },
  methods: {
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    printTransaction(weight, transactionCode, customerName, orderId, numberOfCode) {
        print_transaction(weight, transactionCode, customerName, orderId, numberOfCode);
    },
    manualChanged() {
      if (!this.useBarcodeReader) {
        this.refreshData();
      }
    },
    codeChanged() {
      if (this.useBarcodeReader) {
        this.refreshData();
      }
    },
    refreshData() {
      if (this.packageId) {
        this.$store.dispatch("bigPackageVn/getDetail", {'packageId': this.packageId, 'trancode': this.transactionCode, 'pagination': this.pagination} );
      }
    },
    onChangePackage(value) {
      this.appLoading = true;
      let selectedItem = _.find(this.packages, { ID: value });
      if (selectedItem) {
        this.currentItem.PackageCode = selectedItem.PackageCode;
      }
      this.saveData();
    },
    getListPackageNotTran() {
      this.$store.dispatch("bigPackage/getListNotTransit");
    },
    saveTranWeight(item) {
      this.editTransCode(item);
    },
    createData(username = "") {
      this.getListPackageNotTran();
      this.$store.commit("bigPackageVn/setDetail", {
        data: {
          ID: 0,
          CreatedDate: new Date(),
          PackageCode: '',
          BigPackageID: -1,
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
          name: "StoreManagerVNDetail",
          params: {
          Pid: 'nhap-bao-moi',
          title: 'Nhập bao mới'
          }
      });
    },
    saveData() {
      this.$store.dispatch("bigPackageVn/setDetail", {
        data: this.currentItem,
        id: this.currentItem.ID
      });
    },
    editTransCode: _.debounce(
      function(item) {
        var data = {
          ID: item.ID,
          Weight: item.Weight,
          Length: item.Length,
          Width: item.Width,
          Height: item.Height,
          Volume: item.Volume,
          OrderID: item.OrderID,
          PackageType: item.PackageType,
          OrderTransactionCode: item.TransactionCode,
          Status: configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN,
          PackageId: this.packageId,
          FilterTransaction: this.transactionCode
        };
        data.Type = "transaction";
        data.ModifiedBy = this.$store.state.authentication.user.username;
        data.Status =
          data.Weight > 0
            ? configs.PACKAGE_STATUS_ENUM.DA_VE_VN
            : configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN;
        this.$store.dispatch("orderTransaction/postOrderTransaction", data);
      },
      500,
      {
        leading: false,
        trailing: true
      }
    )
  }
};
</script>
